export enum ScanModeEnum {
  JustScan = 'Just Scan',
  AccessControl = 'Access Control',
  Headcount = 'Headcount',
  OneTimeEntry = 'One-Time Entry',
  OneTimeEntryAndAccessControl = 'One-Time Entry and Access Control',
  HeadcountAndAccessControl = 'Headcount and Access Control'
}

export enum ScanModeValue {
  JustScan = '0',
  AccessControl = '1',
  DupeCheck = '2',
  DupeCheckAndAccessControl = '3',
  Headcount = '4',
  OneTimeEntry = '5',
  OneTimeEntryAndAccessControl = '6',
  HeadcountAndAccessControl = '7'
}

export const ACCESS_CONTROL_MODES: ScanModeValue[] = [
  ScanModeValue.AccessControl,
  ScanModeValue.DupeCheckAndAccessControl,
  ScanModeValue.OneTimeEntryAndAccessControl,
  ScanModeValue.HeadcountAndAccessControl
]

export const HEADCOUNT_MODES: ScanModeValue[] = [
  ScanModeValue.Headcount,
  ScanModeValue.HeadcountAndAccessControl
]
